import {useState} from 'react';
import {Button} from '~library/atoms/Button';
import {Input} from '~library/atoms/Input';
import {ResponsiveModal} from '~library/organisms/ResponsiveModal';
import {TrashIcon} from '~library/svg/v2/TrashIcon';
import {tanzanite} from '~libSass/base/_exports.sass';

export const PollOptions = (props) => {
  const {opt, optionNum, canRemove, minOptions, index, optionCallback, isMealOptions, error} =
    props;
  const [showConfirmation, setShowConfirmation] = useState(false);
  const inputRequired = optionNum <= minOptions;
  const {option} = opt;

  const optionPlaceholder = isMealOptions ? `Meal choice ${index + 1}` : `Option ${index + 1}`;

  const handleRemoveOptionClick = (e) => {
    // // todo check for hasVotes before setting showConfirmation, else just remove
    // setShowConfirmation(true)
    optionCallback(index, e, 'remove');
  };

  return (
    <div key={`poll-create-${optionNum}`} className="poll__option">
      <Input
        type="text"
        value={option}
        placeholder={optionPlaceholder}
        aria-label={optionPlaceholder}
        onChange={(e) => optionCallback(index, e, 'update')}
        maxLength={140}
        required={inputRequired}
        autoFocus={opt.autofocus}
        disabled={opt.response_count > 0 ? 'disabled' : false}
        data-qa-id="poll-option"
        error={error}
      />

      {canRemove && (
        <>
          <Button
            variant="transparent"
            data-qa-id={`delete-option-${index}`}
            type="button"
            onClick={(e) => handleRemoveOptionClick(e)}
            disabled={opt.response_count > 0 ? 'disabled' : false}
            ariaLabel={`Remove ${isMealOptions ? 'meal choice' : 'option'}`}
          >
            <TrashIcon ratio={0.5} color={tanzanite} />
          </Button>
          <ResponsiveModal
            isOpen={showConfirmation}
            onClose={() => setShowConfirmation(false)}
            title="Are you sure?"
            body="This poll choice has votes, are you sure you would like to remove it?"
            modalId="remove-poll-option"
            primaryAction={(e) => handleRemoveOptionClick(e)}
          />
        </>
      )}
    </div>
  );
};
